/* CPCX: make part-number searches forgiving.
   Owners type numbers the way they're printed on the part: "A 129 820 64 61", "51 21 1 938 286", "1H0-853-714".
   Shopify tokenises on spaces/punctuation, so those find nothing useful. For queries SHAPED like a part number we try
   the collapsed form ("A1298206461") and use it only if it actually finds products; otherwise the query is left alone
   (so "911 964 993" model lists still search normally). Ordinary searches ("560 SEC", "W124 door") are never touched. */
(function () {
  var PN = /^\s*(?:[A-Za-z]{1,2}\s?)?\d[0-9A-Za-z]{0,3}(?:[\s.\-\/]+\d{1,4}){2,6}\s*[A-Za-z]{0,3}\s*$/;
  function candidate(q) {
    if (!q || !PN.test(q)) return null;
    var c = q.replace(/[\s.\-\/]/g, '').toUpperCase();
    return c.length >= 7 && c !== q ? c : null;
  }
  var origFetch = window.fetch, cache = {};
  function hasProducts(c) {
    if (c in cache) return cache[c];
    return (cache[c] = origFetch.call(window, '/search/suggest.json?q=' + encodeURIComponent(c) +
      '&resources[type]=product&resources[limit]=1')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { return !!(j && j.resources && j.resources.results.products && j.resources.results.products.length); })
      .catch(function () { return false; }));
  }
  window.cpcxPartNumberCandidate = candidate;

  document.addEventListener('submit', function (e) {
    var f = e.target; if (!f || !f.querySelector || f.dataset.cpcxChecked) return;
    var input = f.querySelector('input[name="q"]'); if (!input) return;
    var c = candidate(input.value); if (!c) return;
    e.preventDefault(); e.stopImmediatePropagation();
    hasProducts(c).then(function (ok) {
      if (ok) input.value = c;
      f.dataset.cpcxChecked = '1';
      HTMLFormElement.prototype.submit.call(f);   // native submit: no second submit event
    });
  }, true);

  if (origFetch) window.fetch = function (resource, init) {
    var self = this, args = arguments;
    try {
      var url = typeof resource === 'string' ? resource : resource && resource.url;
      if (url && url.indexOf('/search/suggest') !== -1 && url.indexOf('/search/suggest.json') === -1) {
        var u = new URL(url, location.origin), c = candidate(u.searchParams.get('q'));
        if (c) return hasProducts(c).then(function (ok) {
          if (!ok) return origFetch.apply(self, args);
          u.searchParams.set('q', c);
          return origFetch.call(self, typeof resource === 'string' ? u.toString() : new Request(u.toString(), resource), init);
        });
      }
    } catch (_) {}
    return origFetch.apply(self, args);
  };
})();
